import React, { useState } from 'react';
import styled from 'styled-components';

const CollapsibleContainer = styled.div`
    /* Add styles for the collapsible container */
`;

const CollapsibleButton = styled.button`
    /* Add styles for the button */
    /*background: none;
    border: none;
    color: white;
    cursor: pointer;
    font-size: 1.5rem;
    padding: 0;
    margin: 0;
    text-align: right;*/
`;

const CollapsibleContent = styled.div`
    /* Add styles for the content */
    overflow: hidden;
    transition: max-height 0.3s ease-out;
    max-height: ${(props) => (props.isOpen ? '500px' : '0px')}; 
`;

const Collapsible = ({ children, isOpen, onToggle }) => {
    return (
        <CollapsibleContainer>
        
            <CollapsibleButton onClick={onToggle}>
                {isOpen ? '▲' : '▼'} 
            </CollapsibleButton>
            <CollapsibleContent isOpen={isOpen}>
                {children}
            </CollapsibleContent>
        </CollapsibleContainer>
    );
};

export default Collapsible;